var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.484 11.976L22.635 6.632V17.259L16.484 11.976ZM8.558 12.881L10.718 14.756C11.057 15.044 11.499 15.218 11.982 15.218H11.999H11.998H12.012C12.496 15.218 12.938 15.043 13.281 14.753L13.278 14.755L15.438 12.88L22.004 18.519H1.995L8.558 12.881ZM1.986 5.365H22.016L12.395 13.721C12.2868 13.8066 12.1529 13.8531 12.015 13.853H12.001H12.002H11.988C11.8496 13.8532 11.7152 13.8063 11.607 13.72L11.608 13.721L1.986 5.365ZM1.365 6.631L7.515 11.975L1.365 17.255V6.631ZM22.965 4.19C22.725 4.07 22.443 4 22.144 4H1.859C1.56916 4.00007 1.28331 4.06751 1.024 4.197L1.035 4.192C0.724573 4.34511 0.463148 4.58198 0.280254 4.87585C0.0973606 5.16971 0.000287348 5.50887 0 5.855L0 18.027C0.000529404 18.5196 0.196452 18.9919 0.54478 19.3402C0.893108 19.6885 1.36539 19.8845 1.858 19.885H22.141C22.6336 19.8845 23.1059 19.6885 23.4542 19.3402C23.8025 18.9919 23.9985 18.5196 23.999 18.027V5.859V5.855C23.999 5.128 23.58 4.498 22.97 4.195L22.959 4.19H22.965Z",
    fill: "#007FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7cf3d38f1e6ab091fbb36b9efae5e3ab.svg";
export { ForwardRef as ReactComponent };